import { io } from 'socket.io-client';
import { boot } from 'quasar/wrappers';

export default boot(({ app, store }) => {
  class CRMSocket {
    constructor() {
      this.socket = null;
      this.newOrdersQueue = [];
      this.updatedOrdersQueue = [];
      this.updatedPaymentVerificationStateQueue = [];
    }

    disconnect() {
      if (this.socket != null && typeof this.socket != 'undefined') {
        this.socket.disconnect();
      }
    }

    connect(token) {
      if (token != null && typeof token != 'undefined') {
        const config = process.env.CRM_SOCKET.client;
        config.transports = ['polling'];
        config.auth = {};
        config.auth.token = token;
        config.reconnectionAttempts = 5;
        config.reconnectionDelay = 5000;

        this.socket = io(process.env.CRM_SOCKET.url, config);
        this.addEventlisteners();
      }
    }

    reconnect(token) {
      try {
        if (this.socket != null && typeof this.socket != 'undefined') {
          this.disconnect();
          this.connect(token);
        } else {
          this.connect(token);
        }
      } catch (e) {
        console.log('CRMSocket.reconnect', e);
      }
    }

    test() {
      if (this.socket != null && typeof this.socket != 'undefined') {
        this.socket.emit('test', { hello: 'world' });
      }
    }

    addEventlisteners() {
      try {
        this.socket.on('connect', () => {
          console.log('Successfull connection', this.socket.id);

          this.socket.on('reject', () => {
            console.log('CRMSocket.reject');
            this.disconnect();
          });

          this.socket.on('accepted', () => {
            console.log('CRMSocket.accepted');

            this.socket.on('newOrderComment', (data) => {
              console.log('newOrderComment', data);
              const orders = data.data;
              if (Object.prototype.toString.call(orders) === '[object Array]') {
                if (orders.length > 0) {
                  if (Object.prototype.hasOwnProperty.call(orders[0], 'id')) {
                    orders.forEach((order) => {
                      this.updatedOrdersQueue.push(order);
                    });
                  }
                  store.commit('queue/updatedOrders', JSON.parse(JSON.stringify(this.updatedOrdersQueue)));
                }
              }
            });

            this.socket.on('updatedPaymentVerificationState', (data) => {
              const state = data.data;
              if (Object.prototype.toString.call(state) === '[object Object]') {
                if (Object.prototype.hasOwnProperty.call(state, 'user_updated')) {
                  this.updatedPaymentVerificationStateQueue.push(state);
                  store.commit(
                    'queue/updatedPaymentVerificationState',
                    JSON.parse(JSON.stringify(this.updatedPaymentVerificationStateQueue))
                  );
                }
              }
            });

            this.socket.on('newOrder', (data) => {
              const orders = data.data;
              if (Object.prototype.toString.call(orders) === '[object Array]') {
                if (orders.length > 0) {
                  if (Object.prototype.hasOwnProperty.call(orders[0], 'id')) {
                    this.newOrdersQueue.push(orders[0]);
                  }
                  store.commit('queue/newOrders', JSON.parse(JSON.stringify(this.newOrdersQueue)));
                }
              }
            });

            this.socket.on('updatedOrder', (data) => {
              const orders = data.data;
              if (Object.prototype.toString.call(orders) === '[object Array]') {
                if (orders.length > 0) {
                  if (Object.prototype.hasOwnProperty.call(orders[0], 'id')) {
                    orders.forEach((order) => {
                      this.updatedOrdersQueue.push(order);
                    });
                  }
                  store.commit('queue/updatedOrders', JSON.parse(JSON.stringify(this.updatedOrdersQueue)));
                }
              }
            });
          });

          this.socket.on('testcallback', (data) => {
            console.log('Server emitted ', data);
          });
        });

        this.socket.on('reconnection_attempt', (reason) => {
          console.log('CRMSocket.reconnection_attempt', reason);
        });

        this.socket.on('disconnect', (reason) => {
          console.log('CRMSocket.disconnect', reason);
        });

        this.socket.on('connect_error', (error) => {
          console.error('CRMSocket.connect_error', error);
        });
      } catch (e) {
        console.log('CRMSocket.addEventlisteners', e);
      }
    }

    popNewOrdersQueue(ids) {
      ids.forEach((id) => {
        const index = this.newOrdersQueue.findIndex((el) => el.id === id);
        if (index > -1) {
          this.newOrdersQueue.splice(index, 1);
        }
      });
      store.commit('queue/newOrders', JSON.parse(JSON.stringify(this.newOrdersQueue)));
    }

    popUpdatedOrdersQueue(ids) {
      ids.forEach((id) => {
        const index = this.updatedOrdersQueue.findIndex((el) => el.id === id);
        if (index > -1) {
          this.updatedOrdersQueue.splice(index, 1);
        }
      });
      store.commit('queue/updatedOrders', JSON.parse(JSON.stringify(this.updatedOrdersQueue)));
    }

    popUpdatedPaymentVerificationStateQueue(dates) {
      dates.forEach((date) => {
        const index = this.updatedPaymentVerificationStateQueue.findIndex((el) => el.date_updated === date);
        if (index > -1) {
          this.updatedPaymentVerificationStateQueue.splice(index, 1);
        }
      });
      store.commit(
        'queue/updatedPaymentVerificationState',
        JSON.parse(JSON.stringify(this.updatedPaymentVerificationStateQueue))
      );
    }
  }

  app.config.globalProperties.$crmsocket = new CRMSocket();
});
